import { COOKIE_NAME } from '@comparacar/lib/src/utils/ab-testing'
import Cookies from 'js-cookie'

export default function useVersionTesting() {
  return Cookies.get(COOKIE_NAME)
}
